import React from 'react';
import { Grid, Box } from '@mui/material';
import styles from './paymentTracking.module.scss';
import { Tracking } from 'components/Tracking';

const PaymentTracking = () => {
  return (
    <Box className={styles.dashboardContainer}>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Tracking />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PaymentTracking;
